import { DynamicModule, Module, Global } from '@nestjs/common';
import { HttpModule, HttpService } from '@nestjs/axios';
import { AsyncConfiguration, Configuration } from './configuration';

import { AreYouOkApi } from './api/areYouOk.service';
import { ConfigApi } from './api/config.service';
import { HealthApi } from './api/health.service';
import { SafetyCheckApi } from './api/safetyCheck.service';

@Global()
@Module({
  exports: [
    AreYouOkApi,
    ConfigApi,
    HealthApi,
    SafetyCheckApi,
  ],
})
export class ApiModule {
  static forRootAsync(options: AsyncConfiguration): DynamicModule {

    const optionsProvider = {
      provide: Configuration,
      useFactory: options.useFactory,
      inject: options.inject,
    };

    const httpModule = HttpModule.registerAsync({
      useFactory: (options: Configuration) => ({
        httpsAgent: options.httpsAgent,
        httpAgent: options.httpAgent,
      }),
      extraProviders: [
        ...(options.providers || []),
        optionsProvider,
      ],
      inject: [ Configuration ],
      imports: [ ...(options.imports || []) ]
    });

    return {
      module: ApiModule,
      providers: [
        ...(options.providers || []),
        optionsProvider,

        {
          provide: AreYouOkApi,
          useClass: AreYouOkApi,
          ...(options.scope && { scope: options.scope }),
        },

        {
          provide: ConfigApi,
          useClass: ConfigApi,
          ...(options.scope && { scope: options.scope }),
        },

        {
          provide: HealthApi,
          useClass: HealthApi,
          ...(options.scope && { scope: options.scope }),
        },

        {
          provide: SafetyCheckApi,
          useClass: SafetyCheckApi,
          ...(options.scope && { scope: options.scope }),
        },

      ],
      imports: [
        ...(options.imports || []),
        httpModule,
      ]
    };
  }

  constructor( httpService: HttpService) { }
}
